import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatSnackBarModule } from '@angular/material';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AgmCoreModule } from '@agm/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import {
	SocialLoginModule,
	AuthServiceConfig,
	GoogleLoginProvider,
	FacebookLoginProvider
} from 'angularx-social-login';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { MatDialogModule } from '@angular/material/dialog';

// common file
import { Common } from './common/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SellpropertyComponent } from './sellproperty/sellproperty.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { VerifyotpComponent } from './verifyotp/verifyotp.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';

import { NgxPaginationModule } from 'ngx-pagination';
import { AppService } from './app.service';
import { ListingComponent } from './listing/listing.component';
import { PropertysingleComponent } from './propertysingle/propertysingle.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Authinterceptor } from './authonterceptor';
import { googleNearResult } from './google/nearplaceresult';

import { FeedbackComponent } from './common/feedback/feedback.component';
import { TermsconditionComponent } from './termscondition/termscondition.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { CareersComponent } from './careers/careers.component';
import { RequestinfoComponent } from './requestinfo/requestinfo.component';
import { PropertytypeComponent } from './propertytype/propertytype.component';
import { HelpcenterComponent } from './helpcenter/helpcenter.component';
import { SalesenquiryComponent } from './salesenquiry/salesenquiry.component';
import { PropertyallComponent } from './propertyall/propertyall.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { ReportproblemComponent } from './reportproblem/reportproblem.component';
import { ContactComponent } from './contact/contact.component';
import { PropiracontactComponent } from './propiracontact/propiracontact.component';

import { SharedModule } from './shared.module';

import { SimpleScrollSpyModule } from 'angular-simple-scroll-spy';
import { ListforsaleComponent } from './listforsale/listforsale.component';
import { MsgboxComponent } from './msgbox/msgbox.component';
import { QuicklistingComponent } from './quicklisting/quicklisting.component';
import { RequestCallbackComponent } from './request-callback/request-callback.component';
import { FranchiseeFormComponent } from './franchisee-form/franchisee-form.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UserFeedbackComponent } from './user-feedback/user-feedback.component';
import { SalespropertiesComponent } from './salesproperties/salesproperties.component';

export const BS_DROPDOWN_DEFAULT = {
	isAnimated: false,
	autoClose: true
};

const config = new AuthServiceConfig([
	{
		id: GoogleLoginProvider.PROVIDER_ID,
		provider: new GoogleLoginProvider('295867526286-06c53e2vavtji481udllj47bbo3u5p01.apps.googleusercontent.com')
	},
	{
		id: FacebookLoginProvider.PROVIDER_ID,
		//provider: new FacebookLoginProvider('549053135914813')
		provider: new FacebookLoginProvider('3501319223238121')
	}
]);

export function provideConfig() {
	return config;
}

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		FooterComponent,
		HomeComponent,
		SellpropertyComponent,
		VerifyotpComponent,
		ForgotpasswordComponent,
		ListingComponent,
		PropertysingleComponent,
		PrivacypolicyComponent,
		PagenotfoundComponent,
		FeedbackComponent,
		TermsconditionComponent,
		AboutusComponent,
		CareersComponent,
		RequestinfoComponent,
		PropertytypeComponent,
		HelpcenterComponent,
		SalesenquiryComponent,
		TestimonialsComponent,
		ReportproblemComponent,
		ContactComponent,
		PropiracontactComponent,
		PropertyallComponent,
		ListforsaleComponent,
		MsgboxComponent,
		QuicklistingComponent,
		RequestCallbackComponent,
		FranchiseeFormComponent,
		UserFeedbackComponent,
		SalespropertiesComponent
	],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		BrowserAnimationsModule,
		LazyLoadImageModule,
		MatButtonModule,
		MatSnackBarModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		GooglePlaceModule,
		NgMultiSelectDropDownModule.forRoot(),
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyC_zIkv5VqOaL9AedqcoP3kkoODRPCTJp4'
		}),
		NgxPaginationModule,
		SocialLoginModule,
		InfiniteScrollModule,
		NgxSpinnerModule,
		MatDialogModule,
		AutocompleteLibModule,
		SharedModule,
		SimpleScrollSpyModule,
		// BsDropdownModule.forRoot(),
		NgxIntlTelInputModule,
		BsDropdownModule
	],
	entryComponents: [ MsgboxComponent ],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: Authinterceptor,
			multi: true
		},
		{ provide: AuthServiceConfig, useFactory: provideConfig },
		{
			provide: BsDropdownConfig,
			useValue: BS_DROPDOWN_DEFAULT
		},
		AppService,
		googleNearResult,
		Common,
		InfiniteScrollModule,
		FooterComponent
	],
	bootstrap: [ AppComponent ],
	schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}
